import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const RedLP = lazy(() => import('@/pages/red-lp/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const ThankYouPage = lazy(() => import('@/pages/thank-you/page'));
const WeChatQR = lazy(() => import('@/pages/wechat-qr/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <RedLP />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '/wechat-qr',
    element: <WeChatQR />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
